module.exports = __webpack_public_path__ + "img/coinbankB18.5bbedf00.jpg";